export class Aviso {
    idAviso: number;
    textoAviso: string;
    fechaInicio: Date;
    fechaFin: Date;
    archivos: any[];
    eliminarPrevios: Boolean;
}